import { ReactNode, useCallback, useState } from "react"
import { Box, BoxProps, VStack } from "@chakra-ui/react"

import {
  selectActiveToken,
  selectDepositAmount,
  setLockTime,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { LOCK_TIMES } from "#/shared/constants"

import DepositDurationBox from "./DepositDurationBox"

type DepositDurationProps = BoxProps & {
  children: ReactNode
  extendBoost?: boolean
}

export default function DepositDuration({
  children,
  extendBoost,
  ...props
}: DepositDurationProps) {
  const [lockTimeIndex, setLockTimeIndex] = useState(0)

  const depositAmount = useDappSelector(selectDepositAmount)
  const dispatch = useDappDispatch()
  const token = useDappSelector(selectActiveToken)

  const depositDurationSelectHandler = useCallback(
    (duration: number) => {
      const lockValueIndex = LOCK_TIMES.findIndex(
        ({ period }) => period === duration,
      )

      dispatch(setLockTime(LOCK_TIMES[lockValueIndex]))
      setLockTimeIndex(lockValueIndex)
    },
    [dispatch],
  )

  return (
    <Box {...props}>
      {children}
      <VStack gap={2}>
        {LOCK_TIMES.map(({ period, multiplier }, index) => (
          <DepositDurationBox
            key={period}
            token={token}
            multiplier={multiplier}
            isActive={lockTimeIndex === index}
            duration={period}
            onClick={depositDurationSelectHandler}
            userAmount={depositAmount}
            extendBoost={extendBoost}
          />
        ))}
      </VStack>
    </Box>
  )
}
